module.exports = __webpack_public_path__ + "images/b0afa31ac7e5eac381afd6f78bad0ce8.png";